import Vue from 'vue';
import store from './../../store';
import currencyTransformer from './../../transformers/currency';

const success = ({ data }, resolve) => {
  const currencies = currencyTransformer.fetchCollection(data.data);
  store.dispatch('fetchCurrencies', currencies);
  resolve(currencies);
};

const failed = () => {
};


export default () => (
  new Promise((resolve, reject) => {
    Vue.$http.get('/account/currencies')
    .then((response) => {
      success(response, resolve);
    })
    .catch((error) => {
      failed(error, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/account/currencies.js